<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>{{ websiteSettings.SYSTEM_NAME }}</h3>
          <p>{{ websiteSettings.FOOTER_TEXT }}</p>
        </div>
        
        <div class="footer-section">
          <h4>{{ $t('Quick Links') }}</h4>
          <ul>
            <li><router-link to="/e-commerce-web">{{ $t('Home') }}</router-link></li>
            <li><router-link to="/e-commerce-web">{{ $t('Products') }}</router-link></li>
            <li><router-link to="/e-commerce-web/cart">{{ $t('Cart') }}</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>{{ $t('Contact Us') }}</h4>
          <p>{{ $t('Email') }}: {{ websiteSettings.MAIL }}</p>
          <p>{{ $t('phone number') }}: {{ websiteSettings.PHONE }}</p>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} {{ websiteSettings.SYSTEM_NAME }}. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppFooter',
  data() {
    return {
      storeName: 'TechStore'
    }
  },
  computed: {
    ...mapState({
      websiteSettings: state => state.websiteSettings
    }),
  },
}
</script>

<style scoped>
.app-footer {
  background: #333;
  color: white;
  padding: 40px 0 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-section h3,
.footer-section h4 {
  color: #fff;
  margin-bottom: 15px;
}

.footer-section h3 {
  font-size: 24px;
}

.footer-section h4 {
  font-size: 18px;
  margin-bottom: 15px;
}

.footer-section p {
  color: #aaa;
  line-height: 1.6;
  margin-bottom: 10px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 8px;
}

.footer-section ul li a {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #2ed573;
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: 20px;
  text-align: center;
}

.footer-bottom p {
  color: #aaa;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>